import { format, isAfter, sub } from 'date-fns'
import { computed, makeObservable, observable } from 'mobx'
import type { StrapiDataT } from 'src/types/common/api'

import { EMPTY_NUMBER_ID } from '@/constant/common'
import { DTO } from '../DTO'

export class AcademyNotice extends DTO {
  id = EMPTY_NUMBER_ID
  title = ''
  content = ''
  createDatetime: Date = new Date()
  type: res.AcademyNotice['type'] = 'NOTICE'

  constructor(data?: StrapiDataT<res.AcademyNotice>) {
    super()

    makeObservable(this, {
      id: observable,
      title: observable,
      content: observable,
      createDatetime: observable,
      type: observable,
      korTag: computed,
      isNew: computed,
    })

    if (data) {
      this.id = data.id
      this.title = data.title
      this.content = data.content
      this.type = data.type
      this.createDatetime = new Date(data.publishedAt ?? data.createdAt)
    }
  }

  get korTag() {
    if (this.type === 'NOTICE') return '공지'
    if (this.type === 'CONTENT') return '콘텐츠'
  }

  get isNew() {
    if (this.createDatetime) {
      const date = new Date()
      const prev3days = sub(date, { days: 3 })
      return isAfter(this.createDatetime, prev3days)
    }
  }

  get date() {
    if (this.createDatetime) {
      return format(this.createDatetime, 'yyyy.MM.dd')
    }
  }
}
